var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11656(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4E4F54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.23 63.9164C65.1675 65.8123 62.4591 66.8539 59.6466 66.8331H36.5425C26.8133 66.1248 26.7925 51.9581 36.5425 51.2498H36.6466C31.0216 35.5414 50.2508 27.7914 58.3341 37.5623V37.5831C59.7925 39.3748 60.8966 41.7498 61.3966 44.7706C64.1675 45.1248 66.4175 46.4789 68.0216 48.3956C71.6675 52.7081 71.98 59.7498 67.23 63.9164Z",
    stroke: "white",
    strokeWidth: 3.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1247 52.1044C39.0413 51.5627 37.8538 51.2711 36.6455 51.2502",
    stroke: "white",
    strokeWidth: 3.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.02 45.6667C59.1034 45.125 60.2909 44.8333 61.4992 44.8125",
    stroke: "white",
    strokeWidth: 3.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.771 42.7084C70.771 45.0001 69.7085 47.0626 68.021 48.3959C66.4168 46.4792 64.1668 45.1251 61.396 44.7709C60.896 41.7501 59.7918 39.3751 58.3335 37.5834V37.5626C59.646 36.2292 61.4793 35.4167 63.4793 35.4167C67.5002 35.4167 70.771 38.6876 70.771 42.7084Z",
    stroke: "white",
    strokeWidth: 3.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11656);
export default __webpack_public_path__ + "static/media/Group 11656.fc9091a6232830d2b725e4ad38c50b99.svg";
export { ForwardRef as ReactComponent };